import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { isStaleChunkError, reloadForStaleChunk } from './app/core/stale-chunk/stale-chunk';

// After a deploy, a tab opened on the previous build asks for chunks that no longer exist. Lazy routes are handled
// by the router (see app.config.ts); this catches any other dynamic import that fails the same way.
if (typeof window !== 'undefined') {
  window.addEventListener('unhandledrejection', (event) => {
    if (isStaleChunkError(event.reason)) {
      reloadForStaleChunk();
    }
  });
}

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
